// extracted by mini-css-extract-plugin
module.exports = {"alfredTools":"IaNbr1aV","leftTools":"uV6quT1K","toolsWrapper":"trxfCrHg","researchDropdowns":"srxkDV8U","researchDropdownsDivider":"PNxkV2od"};